import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, FileEdit, Globe2, Trash2, Settings, CheckCircle2, Clock, Library } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";

export default function Study() {
  const [sermons, setSermons] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();
  const { user } = useAuth();

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/admin/sermons");
      setSermons(r.data);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const createNew = async () => {
    const r = await api.post("/admin/sermons", { title: "Nueva prédica" });
    nav(`/estudio/predica/${r.data.id}`);
  };

  const togglePublish = async (s) => {
    try {
      if (s.status === "published") {
        await api.post(`/admin/sermons/${s.id}/unpublish`);
        toast.success("Movido a borrador");
      } else {
        await api.post(`/admin/sermons/${s.id}/publish`);
        toast.success("¡Prédica publicada!");
      }
      load();
    } catch (e) { toast.error("No se pudo actualizar"); }
  };

  const remove = async (id) => {
    if (!window.confirm("¿Eliminar esta prédica?")) return;
    await api.delete(`/admin/sermons/${id}`);
    toast.success("Eliminada");
    load();
  };

  return (
    <div className="max-w-6xl mx-auto px-4 md:px-8 py-10" data-testid="study-page">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
        <div>
          <div className="eyebrow mb-2">Estudio privado</div>
          <h1 className="font-serif text-3xl md:text-5xl font-bold text-[#13302A]">Bendiciones, Pastor {user?.name?.split(" ")[0] || "Osvaldo"}</h1>
          <p className="text-[#52635C] mt-1">Tus borradores y prédicas publicadas en un solo lugar.</p>
        </div>
        <div className="flex gap-2">
          <Link to="/estudio/biblioteca" className="btn-ghost" data-testid="btn-library"><Library size={16} /> Biblioteca</Link>
          <Link to="/estudio/ajustes" className="btn-ghost" data-testid="btn-settings"><Settings size={16} /> Ajustes</Link>
          <button onClick={createNew} className="btn-gold" data-testid="btn-new-sermon"><Plus size={16} /> Nueva prédica</button>
        </div>
      </div>

      {loading ? (
        <div className="text-[#52635C]">Cargando…</div>
      ) : sermons.length === 0 ? (
        <div className="card-warm p-10 text-center">
          <p className="text-[#52635C] mb-4">Aún no tenés prédicas. Creá la primera.</p>
          <button onClick={createNew} className="btn-gold" data-testid="btn-create-first"><Plus size={16} /> Crear mi primera prédica</button>
        </div>
      ) : (
        <div className="grid gap-4">
          {sermons.map((s) => (
            <div key={s.id} className="card-warm p-5 flex flex-wrap items-center gap-4" data-testid={`study-row-${s.id}`}>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  {s.status === "published" ? (
                    <span className="badge-gold"><CheckCircle2 size={12} /> Publicada</span>
                  ) : (
                    <span className="badge-soft"><Clock size={12} /> Borrador</span>
                  )}
                  {s.series && <span className="text-xs text-[#52635C]">· {s.series}</span>}
                </div>
                <h3 className="font-serif text-lg font-semibold text-[#13302A] truncate">{s.title}</h3>
                {s.bible_reference && <div className="font-mono text-xs text-[#1F4A40]">{s.bible_reference}</div>}
              </div>
              <div className="flex gap-2 flex-wrap">
                <Link to={`/estudio/predica/${s.id}`} className="btn-ghost !min-h-10" data-testid={`btn-edit-${s.id}`}><FileEdit size={16} /> Editar</Link>
                <button onClick={() => togglePublish(s)} className="btn-primary !min-h-10 !px-4" data-testid={`btn-pub-${s.id}`}>
                  <Globe2 size={16} /> {s.status === "published" ? "Despublicar" : "Publicar"}
                </button>
                <button onClick={() => remove(s.id)} className="btn-ghost !min-h-10" aria-label="Eliminar" data-testid={`btn-del-${s.id}`}><Trash2 size={16} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
